<template>
  <sales-list-item
    :item="sale"
    as="a"
    split
    :alert="sale.alertPrice"
    @click.native.stop.prevent="openSale"
  >
    <align small-gap>
      <icon-button
        v-if="sale.notes"
        icon="info"
        :tooltip="sale.notes"
      />

      <template v-if="isLadderCard">
        <icon-button
          v-if="isStaff && purgatory"
          icon="move_to_inbox"
          tooltip="Move to sales"
          @click.stop.prevent="$emit('moveToSales', sale)"
        />

        <icon-button
          v-if="isStaff && !purgatory"
          icon="inventory"
          tooltip="Move to purgatory"
          @click.stop.prevent="$emit('moveToPurgatory', sale)"
        />

        <icon-button
          v-if="isStaff && !purgatory"
          icon="newspaper"
          tooltip="Add to Headlines"
          @click.stop.prevent="$emit('addToHeadlines', sale)"
        />

        <icon-button
          v-if="isStaff && !purgatory"
          icon="search"
          tooltip="View in Sales History"
          @click.stop.prevent="$emit('viewSalesHistory', sale)"
        />

        <icon-button
          v-if="!purgatory && sale.platform === 'eBay'"
          icon="pageview"
          tooltip="View sale on Terapeak Research"
          @click.stop.prevent="$emit('viewTerapeak', sale)"
        />

        <icon-button
          v-if="isStaff"
          icon="delete_outline"
          tooltip="Delete sale"
          @click.stop.prevent="$emit('deleteSale', purgatory ? sale.itemId : sale.id)"
        />
      </template>
    </align>
  </sales-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

import SalesListItem from '@cardladder/shared/components/SalesListItem';

const THREE_MONTHS_AGO = moment().subtract(3, 'months').startOf('day').toDate();

export default {
  components: {
    SalesListItem,
  },

  props: {
    sale: Object,
    purgatory: Boolean,
    isLadderCard: Boolean,
  },

  data() {
    return {
      menuOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      isStaff: 'isStaff',
    }),

    isEbaySale() {
      return this.sale?.platform === 'eBay';
    },
  },

  methods: {
    openSale() {
      if (this.sale.itemId && this.sale.platform === 'eBay' && this.sale.date < THREE_MONTHS_AGO) {
        this.windowOpen(`/sales-history?saleId=${this.sale.itemId.includes('ebay') ? '' : 'ebay-'}${this.sale.itemId}`);
      } else if (this.sale.url) {
        this.windowOpen(this.sale.url);
      }
    },

    windowOpen(url) {
      if (url) {
        let saleUrl = url;

        if (this.isEbaySale && !url.includes('sales-history')) {
          saleUrl += '?nordt=true&rt=nc&orig_cvip=true';
        }

        window.open(saleUrl, '_blank');
      }
    },
  },
};
</script>
